import { gql } from '@apollo/client';

export const CREATE_API_KEY = gql`
  mutation {
    createUserApiKey
  }
`;

export const UPDATE_USER_PREFERENCES = gql`
  mutation updateUserPreferences(
    $firstname: String
    $lastname: String
    $updatedPreferences: JSON!
  ) {
    updateUserPreferences(
      firstname: $firstname
      lastname: $lastname
      updatedPreferences: $updatedPreferences
    )
  }
`;

export const UPDATE_MY_PASSWORD = gql`
  mutation updateMyPassword(
    $currentPassword: String!
    $newPassword: String!
  ) {
    updateMyPassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
    )
  }
`;

export const ENABLE_REFERRAL_CODE = gql`
  mutation {
    enableReferralCode
  }
`;

export const OPEN_SUPPORT = gql`
  mutation openSupport($organisationId: ID!) {
    openSupport(organisationId: $organisationId)
  }
`;

export const CLOSE_SUPPORT = gql`
  mutation closeSupport($userId: String) {
    closeSupport(userId: $userId)
  }
`;

export const OPEN_VIEW_ONLY_SUPPORT = gql`
  mutation openViewOnlySupport($organisationId: ID!) {
    openViewOnlySupport(organisationId: $organisationId)
  }
`;

export const CLOSE_VIEW_ONLY_SUPPORT = gql`
  mutation closeViewOnlySupport($userId: String) {
    closeViewOnlySupport(userId: $userId)
  }
`;

export const UPDATE_USER_LAST_AUTH = gql`
  mutation {
    updateUserLastAuth
  }
`;

export const ACCEPT_TERMS_AND_CONDITIONS = gql`
  mutation {
    acceptTermsAndConditions
  }
`;
